import type { NetSuiteExportSalesOrderRequestPayload } from '@vy/api-definition';
import type { QueryClient, UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../../../services/api';
import { queryKeys } from '../../../../services/query-key/query-keys';

export function useExportNetSuiteSalesOrder(
  contractId: string,
  options?: UseMutationOptions<void, unknown, NetSuiteExportSalesOrderRequestPayload>,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (netSuiteExportSalesOrderRequest) => {
      const api = getPrivateApi();

      return api.exportNetSuiteSalesOrder({ netSuiteExportSalesOrderRequest });
    },
    onSuccess: async () => {
      await invalidateContractPages(contractId, queryClient);
    },
    onError: async () => {
      await invalidateContractPages(contractId, queryClient);
    },
    ...options,
  });
}

async function invalidateContractPages(contractId: string, queryClient: QueryClient) {
  const queryKey = queryKeys.contractPage(contractId);

  await queryClient.invalidateQueries(queryKey);
  await queryClient.invalidateQueries(queryKeys.contracts());
}
